export const INVITATION_EXPIRED_PATH = '/auth/invitation-expired';

export const INVITATION_EXPIRED_VARIANT_PARAM = 'variant';

export const INVITATION_TOKEN_PARAM = 'invitationToken';

export const INVITATION_EXPIRED_VARIANT = {
	RENEW: 'renew',
	CONTACT: 'contact',
} as const;

export type InvitationExpiredVariant =
	(typeof INVITATION_EXPIRED_VARIANT)[keyof typeof INVITATION_EXPIRED_VARIANT];

export enum InvitationRenewalOutcome {
	SENT = 'SENT',
	SIGN_IN = 'SIGN_IN',
	INVITATION_PENDING = 'INVITATION_PENDING',
	CONTACT_INVITER = 'CONTACT_INVITER',
}

export const INVITATION_TOKEN_PATTERN = /^[A-Za-z0-9]{16,128}$/;

export const isInvitationToken = (value: string | null | undefined): value is string =>
	typeof value === 'string' && INVITATION_TOKEN_PATTERN.test(value);
